import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { btnDelay, useScale } from "common/utils";
import { Select } from "common/elements/Select/Select";
import parentI18n from "features/shared/i18n";
import { SSO } from "./SSO";
import { useAuthLocale } from "./useAuthLocale";
import { BrandLogo } from "./components/BrandLogo";

export const RegisterScreen = () => {
  const navigate = useNavigate();
  const { width, height, scale } = useScale();
  const { currentLocale, changeLocale, localeOptions, localeLabels } =
    useAuthLocale();
  const [localeOpen, setLocaleOpen] = useState(false);
  const langBtnRef = useRef<HTMLButtonElement>(null);

  const handleEmailRegister = () => {
    btnDelay(() => {
      navigate("/auth/email-register");
    });
  };

  const handleToggleLocale = () => {
    btnDelay(() => {
      setLocaleOpen(!localeOpen);
    });
  };

  const handleCloseLocale = () => {
    setLocaleOpen(false);
  };

  const handleChangeLocale = (locale: string) => {
    changeLocale(locale);
  };

  return (
    <div className="flex-col-el w-full h-full bg-gray2-30">
      {/* メインコンテンツ */}
      <div
        style={{ height }}
        className="flex-col-el items-center justify-start w-full bg-white/40"
      >
        <main
          style={{
            width: width / scale,
            height: height / scale,
            transform: `scale(${scale})`,
          }}
          className="flex-col-el flex-center shrink-0 p-6 origin-top overflow-y-auto"
        >
          <div
            className="flex-col-view self-center"
            style={{
              width: 497,
              height: 109,
              marginBottom: 16,
            }}
          >
            <BrandLogo />
          </div>

          <div className="flex-col-el flex-center bg-white rounded-[16px] p-8">
            <p className="text-[24px] text-textcolor-black text-center mb-4">
              {parentI18n.t("MSG_SIGN_UP_BTN")}
            </p>
            <div className="flex-col-el flex-center max-w-sm w-full gap-6">
              <button
                className="w-[375px] py-3.5 bg-green-100 text-white rounded-[12px] text-[18px] border-none cursor-pointer hover:opacity-90 transition-all"
                onClick={handleEmailRegister}
              >
                {parentI18n.t("MSG_SIGN_UP_WITH_MAIL")}
              </button>
              <SSO signIn={false} />
            </div>

            {/* ログインリンク */}
            <div className="flex-row-el flex-center mt-6">
              <button
                className="bg-white border border-gray2-60 text-textcolor-black rounded-[12px] py-2 px-4 text-[16px] cursor-pointer hover:bg-gray2-20 transition-all"
                onClick={() => {
                  btnDelay(() => {
                    navigate("/auth/login");
                  });
                }}
              >
                {parentI18n.t("MSG_SIGN_ALREADY_ACCOUNT_LOGIN")}
              </button>
            </div>

            {/* 言語切り替えボタン */}
            <div className="flex-row-el flex-center mt-28">
              <div className="flex-row-el items-center gap-3">
                <span className="text-[20px] text-textcolor-black w-[100px] text-right">
                  {parentI18n.t("MSG_PARENT_PAGE_DISPLAY_LANGUAGE")}
                </span>
                <button
                  ref={langBtnRef}
                  onClick={handleToggleLocale}
                  className="border-0 bg-green-100 flex-row-el items-center gap-2 px-6 py-3 rounded-full backdrop-blur-sm shadow-md cursor-pointer transition-all w-[200px]"
                >
                  <span className="material-symbols-outlined text-white !text-[28px]">
                    language
                  </span>
                  <span className="text-body text-white text-[20px] flex-1 text-center">
                    {localeLabels[currentLocale] || localeLabels["ja_kanji"]}
                  </span>
                  <span className="material-symbols-outlined text-white !text-[20px]">
                    expand_more
                  </span>
                </button>
                <span className="w-[100px]" />
              </div>
            </div>

            <Select
              anchorRef={langBtnRef}
              open={localeOpen}
              onClose={handleCloseLocale}
              value={currentLocale}
              onChange={handleChangeLocale}
              options={[...localeOptions]}
            />
          </div>
        </main>
      </div>
    </div>
  );
};
